const IN_ADVANCE_REQUIRED = -48;
const CHECKIN_REQUEST_SUCCESS = ['SUCCESS', 'PENDING'];
const insurancesUtils = require('./utils/insurances');
const RYANAIR_CARRIER_CODE = 'FR';

function someSectionsHaveError(checkinStatus) {
    return Odigeo._.some(Odigeo._.get(checkinStatus, 'checkinInformation.sections'), (section) => {
        return !CHECKIN_REQUEST_SUCCESS.includes(section.status);
    });
}

module.exports = {
    isNotValidBookingStatus(bookingStatus) {
        return !(['CONFIRMED', 'PENDING'].includes(bookingStatus));
    },
    // has the provider a checkin request already?
    isCheckinAlreadyRequested(checkinStatus) {
        return checkinStatus.checkinInformation != null;
    },
    isRequestedCheckinWithErrors(checkinStatus) {
        return this.isCheckinAlreadyRequested(checkinStatus) &&
            someSectionsHaveError(checkinStatus);
    },
    isRequestedCheckinSuccess(checkinStatus) {
        return this.isCheckinAlreadyRequested(checkinStatus) &&
            !someSectionsHaveError(checkinStatus);
    },
    isCheckinServiceNotAvailable(checkinStatus) {
        return !checkinStatus.checkinAvailable;
    },
    // is the provider not able to handle checkin for this booking?
    isCheckinNotAvailable(checkinAvailability) {
        return !checkinAvailability.available;
    },
    // has the user bought the auto checkin product in funnel
    isAutoCheckinProduct(checkinConditions) {
        return Odigeo.Utils.parseJson(Odigeo.Session.get('isAutoCheckinProductBought')) || checkinConditions.autoCheckInProduct;
    },
    hasSeatsAvailable(ancillariesData) {
        const seatMap = ancillariesData.ancillaryOptionsContainer.seatMapResultsResponse || [];
        return seatMap.length > 0;
    },
    hasInsurancesAvailable: insurancesUtils.hasInsurancesAvailable,
    isThereEnoughTimeToHandleSeats(firstDepartureTimestamp) {
        return Date.now() < new Date(firstDepartureTimestamp).setHours(IN_ADVANCE_REQUIRED);
    },
    isMorePassengerInfoNeeded(checkinAvailability) {
        return checkinAvailability.requiresAdvancedPassengerInformation;
    },
    areAllSegmentsRyanairFlights({itinerarySegments}) {
        return itinerarySegments?.every(({sections})=>
            sections?.every(({section}) => section?.carrier?.code === RYANAIR_CARRIER_CODE)
        );
    },
    areAllSegmentsUsingVirtualEmail({itineraryBookings: {itinerarySegments}, buyer: {mail}}) {
        return itinerarySegments?.every(({sections}) =>
            sections?.every(({section}) => {
                const hasValidUserName = section?.carrierCustomerAccount?.username !== undefined;
                const isUsernameDifferentThanEmail = section?.carrierCustomerAccount?.username !== mail;

                return hasValidUserName && isUsernameDifferentThanEmail;
            })
        );
    },
    async getAvailableOffers({checkinData, bookingData}) {
        try {
            const hasSeatsAvailable = this.hasSeatsAvailable(checkinData.ancillariesData);
            const hasEnoughTime = this.isThereEnoughTimeToHandleSeats(bookingData.checkinConditions.firstDepartureTime);
            const hasInsurancesAvailable = await this.hasInsurancesAvailable({checkinData, bookingData});
            const areAllSegmentsRyanairFlights = this.areAllSegmentsRyanairFlights(bookingData.itineraryBookings);
            const areAllSegmentsUsingVirtualEmail = this.areAllSegmentsUsingVirtualEmail(bookingData);
            return {
                hasSeatsAvailable,
                hasEnoughTime,
                hasInsurancesAvailable,
                areAllSegmentsRyanairFlights,
                areAllSegmentsUsingVirtualEmail,
                get seats() {
                    return this.hasSeatsAvailable && this.hasEnoughTime;
                },
                get insurances() {
                    return !this.seats && this.hasInsurancesAvailable;
                },
                get ryanairOffer() {
                    const desktopRequirements = Odigeo.Utils.isDesktop() && this.areAllSegmentsRyanairFlights;
                    const mobileRequirements = Odigeo.Utils.isMobile() && this.areAllSegmentsRyanairFlights && this.areAllSegmentsUsingVirtualEmail;
                    return desktopRequirements || mobileRequirements;
                },
            };
        } catch (e) {
            return {
                hasSeatsAvailable: false,
                hasEnoughTime: false,
                hasInsurancesAvailable: false,
                seats: false,
                insurances: false,
            };
        }
    },
};

